import React from "react";
import ExpandedList from "../ExpandedList";
import styles from "./index.module.scss";
import classNames from "classnames/bind";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {useInfiniteQuery} from "@tanstack/react-query";
import {queryKeys} from "utils";
import {ASSET_REQUEST_LIMIT} from "utils/constants/assets";
import {getAssetList} from "api-v3";

const cn = classNames.bind(styles);

function SearchTab({searchKeyword}) {
  const assetSearchParams = useSelector(state => state.assetLibrary.currentSearchParams);

  const [query] = useSearchParams();

  const keyword = searchKeyword.toLowerCase();
  const searchParams = assetSearchParams;
  const queries = {tab: query.get("tab"), type: query.get("type")};

  const queryKey = queryKeys.asset({keyword, queries});
  const queryFn = async ({pageParam = 0}) => {
    if (keyword) {
      const className = cn("no_results");
      const params = {...searchParams, search: keyword, publicStatus: true};
      params.limit = ASSET_REQUEST_LIMIT;
      params.offset = ASSET_REQUEST_LIMIT * pageParam;
      if (queries.tab === "Model") {
        params.topCategory = "MODEL";
        params.midCategory = "ASSET";
      }

      const response = await getAssetList(params);
      response.data.items.totalCount = response.data.totalCount;
      if (!response.data.items.totalCount) {
        document.getElementsByClassName(className)[0].style.visibility = "visible";
      }
      return response.data.items;
    }
  }
  const options = {
    getNextPageParam: (lastPage, allPages) => {
      return lastPage?.length === ASSET_REQUEST_LIMIT && allPages.length;
    },
    staleTime: 60 * 500,
    cacheTime: 60 * 500,
    enabled: !!keyword,
  };
  
  const {data, fetchNextPage, hasNextPage} = useInfiniteQuery({queryKey, queryFn, ...options});
   
  return (
    <div className={cn("container")}>
      {!!data?.pages[0]?.length ? (
        <>
          {/* <div className={styles.asset_type_list}>
            {ASSET_TYPE_LIST.map(assetType => (
              <button
                onClick={() => setSelectedAssetType(assetType.type)}
                className={cn("asset_type_button", assetType.type === selectedAssetType && "selected")}
              >
                <p className={styles.asset_type_text}>{assetType.name}</p>
              </button>
            ))}
          </div> */}
          <ExpandedList data={data} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage}/>          
        </>
      ) : (
        <p className={cn("no_results")}>No results found</p>
      )}
    </div>
  );
}

export default SearchTab;
